<template>
  <v-row class="pa-0 ma-0">
    <v-col cols="3" class="pa-0">
      <v-row class="pa-0 ma-0">
        <v-col cols="12" class="pa-0">
          <v-list color="transparent">
            <template v-for="(item, index) in items">
              <v-list-item
                v-if="checkRole(item)"
                :key="item.title"
                @click.stop="onSelect(item, index)"
              >
                <v-list-item-avatar>
                  <v-icon :color="selected.key == item.key ? 'primary' : 'grey'">{{ item.icon }}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-col>
        <v-col v-if="data && data.role ==  'admin'" cols="12" class="py-0" align="end">
          <v-select
            :disabled="data.role != 'admin' && data.role != 'owner'"
            :items="data.role == 'admin' ? $PRIVILEGES : $PRIVILEGES_OWNER"
            label="アクセス権限"
            :value="data.role == 'admin' || data.role == 'owner' ? privilege : data.role"
            @change="onChangePrivilege"
            item-text="name"
            item-value="role"
            outlined
            small-chips
          ></v-select>
          <span class="caption">{{ 'v.' + version }}</span>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="9" class="pa-0">
      <v-row class="pa-0 ma-0">
        <v-col cols="12" class="pa-0">
          <template-user
            v-if="selected.key == 'user' && data"
            :item="data"
            :type="'edit'"
            :mode="'profile'"
            :contentsHeight="userHeight"
          >
          </template-user>
          <template-school
            v-if="selected.key == 'schools'"
            :item="userSchool"
            :contentsHeight="userHeight"
            :type="getPrivilegesLevel(data) <= 1 ? 'edit' : 'view'"
          >
          </template-school>
          <template-group
            v-if="selected.key == 'groups'"
            :school="userSchool"
            :group="null"
            id="groups"
            :type="getPrivilegesLevel(data) <= 1 ? 'edit' : 'view'"
          >
          </template-group>
          <template-group
            v-if="selected.key == 'corps'"
            :school="userSchool"
            :group="null"
            id="corps"
            :type="getPrivilegesLevel(data) <= 1 ? 'edit' : 'view'"
          >
          </template-group>
          <template-users
            v-if="selected.key == 'users'"
            :school="userSchool"
            :type="getPrivilegesLevel(data) <= 2 ? 'edit' : 'view'"
          >
          </template-users>
          <template-student-upload
            v-if="selected.key == 'students'"
            :school="userSchool"
            :contentsHeight="contentsHeight"
            :type="getPrivilegesLevel(data) <= 2 ? 'edit' : 'view'"
          >
          </template-student-upload>
          <template-tags
            v-if="selected.key == 'tags'"
            :school="userSchool"
            :type="getPrivilegesLevel(data) <= 2 ? 'edit' : 'view'"
          >
          </template-tags>
          <template-scholae
            v-if="selected.key == 'scholae'"
            :school="userSchool"
            :type="getPrivilegesLevel(data) <= 2 ? 'edit' : 'view'"
          >
          </template-scholae>
          <template-holiday
            v-if="selected.key == 'holiday'"
            :school="userSchool"
            :type="getPrivilegesLevel(data) <= 2 ? 'edit' : 'view'"
          >
          </template-holiday>
          <template-postcode
            v-if="selected.key == 'postcode'"
            :school="userSchool"
            :type="getPrivilegesLevel(data) <= 2 ? 'edit' : 'view'"
          >
          </template-postcode>
          <template-school-primary
            v-if="selected.key == 'sprimary' && data"
            :item="data"
            :type="'edit'"
          >
          </template-school-primary>
          <template-maintenance
            v-if="getPrivilegesLevel(data) == 0 && selected.key == 'maintenance'"
            :school="userSchool"
            :item="data"
            :type="'edit'"
          >
          </template-maintenance>
        </v-col>
      </v-row>
    </v-col>

  <div v-if="logout">
    <app-basic-dialog
      @dismissed="onDismissed"
      title='ログアウト'
      message="ログアウトしますがよろしいですか?"
      :dialog='logout'
      color="error"
      :cancel='true'>
    </app-basic-dialog>
  </div>

  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import TemplateUser from '../../components/user/TemplateUser.vue'
import TemplateSchool from '../../components/user/TemplateSchool.vue'
import TemplateGroup from '../../components/user/TemplateGroup.vue'
import TemplateUsers from '../../components/user/TemplateUsers.vue'
import TemplateStudentUpload from '../../components/user/TemplateStudentUpload.vue'
import TemplateScholae from '../../components/user/TemplateScholae.vue'
import TemplateHoliday from '../../components/user/TemplateHoliday.vue'
import TemplatePostcode from '../../components/user/TemplatePostcode.vue'
import TemplateSchoolPrimary from '../../components/user/TemplateSchoolPrimary.vue'
import TemplateTags from '../../components/user/TemplateTags.vue'
import TemplateMaintenance from '../../components/user/TemplateMaintenance.vue'
Vue.component('template-user', TemplateUser)
Vue.component('template-school', TemplateSchool)
Vue.component('template-group', TemplateGroup)
Vue.component('template-users', TemplateUsers)
Vue.component('template-student-upload', TemplateStudentUpload)
Vue.component('template-scholae', TemplateScholae)
Vue.component('template-holiday', TemplateHoliday)
Vue.component('template-postcode', TemplatePostcode)
Vue.component('template-school-primary', TemplateSchoolPrimary)
Vue.component('template-tags', TemplateTags)
Vue.component('template-maintenance', TemplateMaintenance)
export default {
  data () {
    return {
      loading: false,
      selected: null,
      tempUser: null,
      origUser: null,
      logout: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      privilege: 'shared/privilege',
      version: 'shared/version',
      windowSize: 'shared/windowSize'
    }),
    userSchool () {
      var item = null
      for (var key in this.data.schools) {
        if (this.data.schools[key]) {
          var index = this.schools.findIndex(school => school.key === key)
          if (index !== -1) {
            item = this.schools[index]
            break
          }
        }
      }
      return item
    },
    items () {
      return [
        {
          key: 'user',
          type: 'contents',
          icon: 'mdi-account-circle',
          iconClass: 'indigo white--text',
          title: '個人設定',
          subtitle: '',
          primary: true,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        },
        {
          key: 'schools',
          type: 'contents',
          icon: 'mdi-school',
          iconClass: 'indigo white--text',
          title: '塾設定',
          subtitle: '',
          primary: false,
          roles: { admin: false, owner: true, chief: false, teacher: false, user: false }
        },
        {
          key: 'groups',
          type: 'contents',
          icon: 'mdi-school',
          iconClass: 'indigo white--text',
          title: '教室管理',
          subtitle: '',
          primary: false,
          roles: { admin: false, owner: true, chief: true, teacher: false, user: false }
        },
        {
          key: 'corps',
          type: 'contents',
          icon: 'mdi-account-group',
          iconClass: 'indigo white--text',
          title: 'グループ管理',
          subtitle: '',
          primary: false,
          roles: { admin: false, owner: true, chief: true, teacher: false, user: false }
        },
        {
          key: 'users',
          type: 'contents',
          icon: 'mdi-account',
          iconClass: 'indigo white--text',
          title: 'ユーザ管理',
          subtitle: '',
          primary: false,
          roles: { admin: false, owner: true, chief: true, teacher: false, user: false }
        },
        {
          key: 'scholae',
          type: 'contents',
          icon: 'mdi-domain',
          iconClass: 'warning white--text',
          title: '学校管理',
          subtitle: '',
          primary: false,
          roles: { admin: false, owner: true, chief: true, teacher: false, user: false }
        },
        {
          key: 'students',
          type: 'contents',
          icon: 'mdi-account-box',
          iconClass: 'error white--text',
          title: '生徒管理',
          subtitle: '',
          primary: false,
          roles: { admin: false, owner: true, chief: false, teacher: false, user: false }
        },
        {
          key: 'tags',
          type: 'contents',
          icon: 'mdi-tag',
          iconClass: 'error white--text',
          title: 'タグ管理',
          subtitle: '',
          primary: false,
          roles: { admin: false, owner: true, chief: true, teacher: false, user: false }
        },
        {
          key: 'holiday',
          type: 'contents',
          icon: 'mdi-calendar-plus',
          iconClass: 'error white--text',
          title: '祝日管理',
          subtitle: '',
          primary: false,
          roles: { admin: true, owner: false, chief: false, teacher: false, user: false }
        },
        {
          key: 'postcode',
          type: 'contents',
          icon: 'mdi-at',
          iconClass: 'error white--text',
          title: '郵便番号登録',
          subtitle: '',
          primary: false,
          roles: { admin: true, owner: false, chief: false, teacher: false, user: false }
        },
        {
          key: 'sprimary',
          type: 'contents',
          icon: 'mdi-alert',
          iconClass: 'error white--text',
          title: '塾切替',
          subtitle: '',
          primary: true,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: false }
        },
        {
          key: 'maintenance',
          type: 'contents',
          icon: 'mdi-alert',
          iconClass: 'error white--text',
          title: 'メインテナンス告知',
          subtitle: '',
          primary: false,
          roles: { admin: true, owner: false, chief: false, teacher: false, user: false }
        },
        {
          key: 'logout',
          type: 'contents',
          icon: 'mdi-alert-circle',
          iconClass: 'error white--text',
          title: 'ログアウト',
          subtitle: '',
          primary: true,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        }
      ]
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 80 - 86 - 48 - 1 - 40) + 'px;'
    },
    userHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 40) + 'px;'
    }
  },
  watch: {
    users () {
      this.tempUserInit()
    }
  },
  created () {
    this.selected = this.items[0]
    this.tempUserInit()
    this.itemInit()
  },
  mounted () {
    this.createUser().then(() => {
      this.selected = this.items[0]
    })
  },
  methods: {
    createUser () {
      return new Promise((resolve) => {
        if (this.isUserCreated() === false) {
          var vm = this
          this.loading = true
          var index = this.schools.findIndex(school => school.id === localStorage.id)
          if (index === -1) {
            this.loading = false
            resolve()
            return
          }
          var school = this.schools[index]
          var s = {}
          s[school.key] = true
          var payload = JSON.parse(JSON.stringify(this.$store.getters['users/initial']))
          payload.key = this.user.uid
          payload.email = this.user.email
          payload.schools = s
          payload.primary = school.key
          if (this.user.photoURL) {
            payload.avatar = { path: this.user.photoURL, thumbnail: this.user.photoURL }
          }
          payload.createdAt = parseInt(new Date().getTime())
          payload.updatedAt = parseInt(new Date().getTime())
          this.$store.dispatch('users/create', payload).then(() => {
            vm.loading = false
            resolve()
          })
        } else {
          resolve()
        }
      })
    },
    tempUserInit () {
      this.file = null
      this.tempUser = JSON.parse(JSON.stringify(this.$store.getters['users/initial']))
      if (this.user) {
        this.email = this.user.email
        var index = this.users.findIndex(user => user.key === this.user.uid)
        if (index !== -1) {
          var user = this.users[index]
          this.origUser = JSON.parse(JSON.stringify(user))
          this.tempUser = JSON.parse(JSON.stringify(user))
        }
      }
    },
    itemInit () {
      this.item = JSON.parse(JSON.stringify(this.$store.getters['schools/initial']))
    },
    isUserCreated () {
      var index = this.users.findIndex(user => user.key === this.user.uid)
      return index !== -1
    },
    checkRole (item) {
      if (!this.data) {
        return false
      }
      var role = false
      role = item.roles[this.getPrivilege(this.data)]
      if (role && item.key === 'sprimary') {
        role = this.data.multi
      }
      if (this.data.multi && !this.checkPrimary()) {
        role = item.primary
      }
      return role
    },
    onSelect (item, index) {
      if (item.key === 'logout') {
        this.logout = true
        return
      }
      this.selected = item
    },
    onChangePrivilege (privilege) {
      this.$store.dispatch('shared/setPrivilege', privilege)
      this.selected = this.items[0]
    },
    onDismissed: function (value) {
      var vm = this
      if (this.logout) {
        this.logout = false
        if (value) {
          if (this.data) {
            vm.goto(vm, '/')
            this.$nextTick(function () {
              vm.gisSignOut()
              vm.$store.dispatch('auth/release').then(() => {
                vm.goto(vm, '/')
              })
            })
          }
        }
      }
    }
  }
}
</script>

<style>
</style>
